<TextCell text={headerText} header colspan={1} />

<script>
    import TextCell from "@itslearning/prometheus/assets/lists/TextCell/v1/TextCell.svelte";
    import i18n from "@its-ui/planner-common/i18n";

    export let headerText = i18n.group;
</script>
